import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { AddedMaterial } from 'models/material';
import { formatNumber } from 'utils/format';

type AddedMaterialsSummaryProps = {
    addedMaterials?: AddedMaterial[];
};

const AddedMaterialsSummary: FC<AddedMaterialsSummaryProps> = ({ addedMaterials }) => {
    const { t: translate } = useTranslation(['orders']);

    if (!addedMaterials?.length) {
        return null;
    }

    const materialLabel = (addedMaterial: AddedMaterial) => {
        const codeAndDescription = [addedMaterial.code, addedMaterial.description].filter(Boolean).join(' - ');
        if (codeAndDescription) {
            return codeAndDescription;
        }
        if (typeof addedMaterial.material === 'string') {
            return addedMaterial.material;
        }
        return [addedMaterial.material?.materialCode, addedMaterial.material?.description].filter(Boolean).join(' - ');
    };

    return (
        <Box mt={1}>
            <Typography variant="caption" sx={{ fontWeight: '600' }}>
                {translate('orders:LAB_ADDED_MATERIALS')}:
            </Typography>
            {addedMaterials.map((material, materialIndex) => (
                <Typography key={material._id || materialIndex} variant="caption" display="block">
                    {materialLabel(material)} &mdash; {translate('orders:QUANTITY')}:{' '}
                    {formatNumber(material.quantity || 0)}
                </Typography>
            ))}
        </Box>
    );
};

export default AddedMaterialsSummary;
